import React from "react";
import { FiAlertCircle } from "react-icons/fi";
import { HashLink as Link } from 'react-router-hash-link';
import { Button, Icon, Label } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
import "../../components/Portafolio/src/css/detalle_cursos.css";

interface Props {
    ruta : number;
}

export default function ActualizacionModal({ruta} :Props) {
    const {userStore: {user}, modalStore} = useStore();

    return(
        <div className="modal_pago_alert">
            <div className="head-area">
                <FiAlertCircle/>
                <h2>Acción requerida</h2>
            </div>

            <div>
                <p>Tienes que llenar todos tus datos en tu < br/><span>Ficha Personal</span> para poder inscribirte.</p>
                <div className="botones_modal">

                <Button as={Link} to={`/home/profile/editar/${user?.id}`} onClick={() => {modalStore.closeModal()}} labelPosition='right'>

                    <Button className="badge">
                        <Icon name="alarm" />
                    </Button>

                    <Label as='a' basic pointing='left'>
                        Actualizar Datos
                    </Label>

                </Button>
                    {/* <Button as={Link} to={`/sgpersonas/${user?.userName}`} onClick={() => {modalStore.closeModal()}}>Actualizar datos</Button> */}
                </div>
            </div>
         </div>
    )
    
}